import React, { useContext } from 'react'
import { Alert } from 'components'
import { Button } from 'components/Form'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { CreateBatteryStyles } from './Style'
import { toast } from 'react-toastify'
import { toastConfig } from 'config'
import { updateExecutionFetch } from 'store/middlewares/assessment.crud'
import { Space } from 'styles/GlobalStyle'
import { AssessmentsContext } from './AssessmentsContext'
import { keys, pickBy } from 'lodash'

// cancel=true - ביטול ביצוע מבדק (מעבר ל'לא לביצוע'), cancel=false - החזרת המבדק לביצוע
const UpdateExecutionAlert = (props) => {
    const { handleAlert = () => { }, cancel } = props
    const { setResetRowSelection, selectedAssessments, setSelectedAssessments, assessmentOptions } = useContext(AssessmentsContext)
    const queryClient = useQueryClient()

    const { mutateAsync: updateExecution, isPending } = useMutation({
        mutationFn: updateExecutionFetch,
        onSuccess: ({ data }) => {
            handleAlert(false)
            setResetRowSelection(true)
            setSelectedAssessments(null)
            queryClient.invalidateQueries({ queryKey: assessmentOptions.queryKey })
            toast(`${data.updated_records} מבדקים עודכנו בהצלחה`, toastConfig)
        }
    })

    const assessment_ids = keys(pickBy(selectedAssessments, v => v === true))

    return (
        <Alert
            systemUI
            title={cancel ? "ביטול ביצוע מבדק" : "החזר ביצוע מבדק"}
            footerActions={[]}
            handleAlert={() => handleAlert(false)}
            closeOnClick
        >
            <CreateBatteryStyles>
                <div>
                    <div>
                        {cancel ?
                            "המבדקים שנבחרו יסומנו 'לא לביצוע' ולא ייספרו בסקירה המערכתית" :
                            "המבדקים שנבחרו יחזרו לסטטוס 'לא בוצע'"}
                    </div>
                    <div>
                        {cancel ?
                            "רק מבדקים שעדיין לא בוצעו יעודכנו" :
                            "רק מבדקים בסטטוס 'לא לביצוע' יעודכנו"}
                    </div>
                    <Space />
                    <Button
                        loading={isPending}
                        disabled={isPending || !assessment_ids.length}
                        action={() => updateExecution({ assessment_ids, cancel })}
                        color="thirdly"
                        label={cancel ? "ביטול ביצוע" : "החזר לביצוע"}
                    />
                </div>
            </CreateBatteryStyles>
        </Alert>
    )
}

export default UpdateExecutionAlert
